import React from 'react'
import { useNavigate } from 'react-router-dom'

interface SessionExpiredModalProps {
    isOpen: boolean
    onClose: () => void
    onLoginClick?: () => void
    title?: string
    message?: string | React.ReactNode
    buttonMode?: 'session-expired' | 'close-only'
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({
    isOpen,
    onClose,
    onLoginClick,
    title = 'Session Expired',
    message = 'Session expired - please log in again or close to go back to main menu',
    buttonMode = 'session-expired'
}) => {
    const navigate = useNavigate()

    if (!isOpen) return null

    const handleBackClick = () => {
        onClose()
        navigate('/')
    }

    const handleLoginClick = () => {
        onClose()
        if (onLoginClick) {
            onLoginClick()
        }
    }

    return (
        <div className="modal is-active">
            <style>{`
                .session-expired-buttons {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 1rem;
                    flex-wrap: wrap;
                }

                @media (max-width: 768px) {
                    .session-expired-buttons {
                        flex-direction: column;
                    }
                }
            `}</style>
            <div className="modal-background" onClick={onClose}></div>
            <div className="modal-card" style={{ maxWidth: '500px' }}>
                <div style={{
                    background: '#232043',
                    borderRadius: '18px 18px 0 0',
                    padding: '1.25rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <h2 style={{
                        color: '#fdfa52',
                        fontSize: '1.5rem',
                        fontWeight: 600,
                        margin: 0
                    }}>
                        {title}
                    </h2>
                    <span
                        aria-label="close"
                        onClick={onClose}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '20px',
                            height: '20px',
                            padding: 0,
                            margin: 0,
                            boxShadow: 'none',
                            outline: 'none',
                            flexShrink: 0
                        }}
                    >
                        <span style={{
                            display: 'block',
                            width: '16px',
                            height: '2px',
                            background: '#fdfa52',
                            transform: 'rotate(45deg)',
                            position: 'absolute'
                        }}></span>
                        <span style={{
                            display: 'block',
                            width: '16px',
                            height: '2px',
                            background: '#fdfa52',
                            transform: 'rotate(-45deg)',
                            position: 'absolute'
                        }}></span>
                    </span>
                </div>

                <section className="modal-card-body" style={{
                    background: 'linear-gradient(to right, #fdfa52, #FFAE42)',
                    borderRadius: '0 0 18px 18px',
                    padding: '2rem',
                    textAlign: 'center'
                }}>
                    <div style={{
                        textAlign: 'center',
                        color: '#232043',
                        fontSize: '1.1rem',
                        marginBottom: '2rem',
                        lineHeight: '1.5'
                    }}>
                        {message}
                    </div>

                    <div className="session-expired-buttons">
                        {buttonMode === 'close-only' ? (
                            <button
                                onClick={onClose}
                                style={{
                                    background: '#232043',
                                    color: 'yellow'
                                }}
                            >
                                <span style={{ fontWeight: 700, letterSpacing: 1.2 }}>Close</span>
                            </button>
                        ) : (
                            <>
                                <button
                                    onClick={handleBackClick}
                                    style={{
                                        background: '#232043',
                                        color: 'yellow'
                                    }}
                                >
                                    <span style={{ fontWeight: 700, letterSpacing: 1.2 }}>Back</span>
                                </button>

                                <button
                                    onClick={handleLoginClick}
                                    style={{
                                        background: '#232043',
                                        color: 'yellow'
                                    }}
                                >
                                    <span style={{ fontWeight: 700, letterSpacing: 1.2 }}>Login</span>
                                </button>
                            </>
                        )}
                    </div>
                </section>
            </div>
        </div>
    )
}

export default SessionExpiredModal
